(() => {
  const sections = document.querySelectorAll('[data-rr-v3-experience]');
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.rrV3Ready === 'true') return;
    section.dataset.rrV3Ready = 'true';

    const mainSection = document.querySelector('.product--section');
    const productDetails = mainSection?.querySelector('[data-product-details], .product-details');
    const mainForm = mainSection?.querySelector('[data-product-form]');
    const mainAtc = mainSection?.querySelector('[data-product-atc]');
    const purchaseGuidance = section.querySelector('[data-rr-v3-purchase-guidance]');
    const descriptionHost = section.querySelector('[data-rr-v3-description-host]');
    const existingDescription = mainSection?.querySelector('[data-product-description]');
    const titleBlock = mainSection?.querySelector('.product-block--title, [data-block-type="title"]');
    const vendor = section.querySelector('.rr-v3-story .rr-v3-eyebrow')?.textContent?.trim();
    const story = section.querySelector('.rr-v3-story');
    const galleryColumn = mainSection?.querySelector('.product-gallery-wrapper');
    const experienceInner = section.querySelector('.rr-v3-experience__inner');
    const updateExperienceShell = () => {
      section.classList.toggle('is-shell-collapsed', Boolean(experienceInner && experienceInner.children.length === 0));
    };

    const placeProtectionOffer = () => {
      const protectionOffer = mainSection?.querySelector('.cps_cart');
      const actionWrapper = mainSection?.querySelector('.product-form__action-wrapper');
      const fastCheckout = actionWrapper?.querySelector('.shopify-payment-button');
      if (!protectionOffer || !actionWrapper || protectionOffer.parentElement === actionWrapper) return;
      actionWrapper.insertBefore(protectionOffer, fastCheckout || null);
    };

    placeProtectionOffer();
    const productFormArea = mainSection?.querySelector('[data-product-form-area]');
    if (productFormArea) {
      new MutationObserver(placeProtectionOffer).observe(productFormArea, { childList: true, subtree: true });
    }

    const suppressAutomaticProtectionPopup = () => {
      document.body.classList.add('rr-v3-cps-auto-popup-suppressed');
    };

    const allowIntentionalProtectionPopup = () => {
      const modal = document.querySelector('#modalMainjump2');
      if (modal) modal.style.display = 'none';
      document.body.classList.remove('rr-v3-cps-auto-popup-suppressed');
    };

    const handleProtectionModality = (event) => {
      if (event.target.closest('.quantity-selector__button')) suppressAutomaticProtectionPopup();
      if (event.target.closest('.cps_cart .btn-warranty2')) allowIntentionalProtectionPopup();
    };

    mainSection?.addEventListener('pointerdown', handleProtectionModality, true);
    mainSection?.addEventListener('click', handleProtectionModality, true);
    mainSection?.addEventListener('change', (event) => {
      if (event.target.closest('.quantity-selector__input')) suppressAutomaticProtectionPopup();
    }, true);

    mainSection?.addEventListener('pointerdown', (event) => {
      if (event.target.closest('.rr-v3-accordion summary')) {
        section.dataset.rrV3InputModality = 'pointer';
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') section.dataset.rrV3InputModality = 'keyboard';
    }, true);

    if (productDetails) {
      productDetails.querySelectorAll('.rr-v3-inline-trust').forEach((trust) => trust.remove());
      const formBlock = productDetails.querySelector('.product-block--form, [data-product-form-regular]');
      if (purchaseGuidance) {
        purchaseGuidance.classList.add('rr-v3-details--purchase-column');
        (formBlock || productDetails).insertAdjacentElement('afterend', purchaseGuidance);
      }
      updateExperienceShell();
    }

    if (descriptionHost && existingDescription) {
      descriptionHost.querySelector('[data-rr-v3-empty-description]')?.remove();
      descriptionHost.appendChild(existingDescription);
      existingDescription.closest('.product-block--description')?.remove();
    }

    if (titleBlock && vendor && !titleBlock.querySelector('.rr-v3-product-eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'rr-v3-product-eyebrow';
      eyebrow.textContent = vendor;
      titleBlock.prepend(eyebrow);
    }

    if (story && galleryColumn) {
      const storyHome = document.createComment('R&R product story home');
      story.before(storyHome);

      const placeStory = () => {
        const galleryBounds = galleryColumn.getBoundingClientRect();
        const detailsBounds = productDetails?.getBoundingClientRect();
        const useGalleryColumn = Boolean(
          detailsBounds
          && galleryBounds.width > 0
          && detailsBounds.width > 0
          && galleryBounds.right <= detailsBounds.left + 24
          && Math.abs(galleryBounds.top - detailsBounds.top) < 160
        );
        if (useGalleryColumn && story.parentElement !== galleryColumn) {
          galleryColumn.appendChild(story);
        } else if (!useGalleryColumn && story.parentElement === galleryColumn) {
          storyHome.after(story);
        }
        story.classList.toggle('rr-v3-story--gallery-column', useGalleryColumn);
        section.classList.toggle('is-story-relocated', useGalleryColumn);
        updateExperienceShell();
      };

      placeStory();
      window.addEventListener('resize', placeStory, { passive: true });
      if ('ResizeObserver' in window) {
        const storyPlacementObserver = new ResizeObserver(placeStory);
        storyPlacementObserver.observe(mainSection.querySelector('.product--outer') || mainSection);
      }
    }

    const optionGroups = mainSection?.querySelectorAll('.options-selection__radios') || [];
    optionGroups.forEach((group) => {
      const values = group.querySelector('.options-selection__option-values');
      const labels = [...group.querySelectorAll('.options-selection__option-value-label')];
      const longestLabel = labels.reduce((length, label) => Math.max(length, label.textContent.trim().length), 0);

      if (values && longestLabel > 22) values.classList.add('rr-v3-option-values--long');

      labels.forEach((label) => {
        if (label.querySelector('.rr-v3-option-label__text')) return;
        const textNodes = [...label.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (!textNodes.length) return;
        const text = document.createElement('span');
        text.className = 'rr-v3-option-label__text';
        text.textContent = textNodes.map((node) => node.textContent.trim()).join(' ');
        textNodes.forEach((node) => node.remove());
        label.appendChild(text);
      });
    });

    mainSection?.addEventListener('change', (event) => {
      const input = event.target.closest('.options-selection__option-value-input');
      const label = input?.closest('.options-selection__option-value-label');
      if (!label) return;
      label.classList.remove('rr-v3-option-label--confirmed');
      window.requestAnimationFrame(() => label.classList.add('rr-v3-option-label--confirmed'));
      window.setTimeout(() => label.classList.remove('rr-v3-option-label--confirmed'), 260);
    });

    const gallery = mainSection?.querySelector('product-gallery');
    const viewer = gallery?.querySelector('[data-swiper-viewer]');
    const thumbnailRail = gallery?.querySelector('[data-swiper-navigation]');
    if (gallery && viewer && !gallery.querySelector('.rr-v3-gallery-counter')) {
      const counter = document.createElement('div');
      counter.className = 'rr-v3-gallery-counter';
      counter.setAttribute('aria-live', 'polite');
      viewer.style.position = 'relative';
      viewer.appendChild(counter);

      const updateCounter = () => {
        const slides = [...viewer.querySelectorAll('.swiper-slide')].filter((slide) => !slide.classList.contains('swiper-slide-duplicate'));
        const active = slides.findIndex((slide) => slide.classList.contains('swiper-slide-active'));
        if (slides.length) counter.textContent = `${Math.max(active, 0) + 1} / ${slides.length}`;
      };

      updateCounter();
      new MutationObserver(updateCounter).observe(viewer, { subtree: true, attributes: true, attributeFilter: ['class'] });

      let galleryRefreshFrame;
      const refreshGalleryLayout = () => {
        window.cancelAnimationFrame(galleryRefreshFrame);
        galleryRefreshFrame = window.requestAnimationFrame(() => {
          const swiper = viewer.swiper;
          if (!swiper) return;
          const activeIndex = swiper.activeIndex;
          swiper.update();
          swiper.slideTo(activeIndex, 0, false);
        });
      };

      refreshGalleryLayout();
      window.setTimeout(refreshGalleryLayout, 250);
      window.addEventListener('resize', refreshGalleryLayout, { passive: true });

      if (thumbnailRail) {
        let currentThumbnail;
        const customScrollbar = document.createElement('div');
        const customScrollbarThumb = document.createElement('span');
        customScrollbar.className = 'rr-v3-thumbnail-scrollbar';
        customScrollbar.setAttribute('role', 'scrollbar');
        customScrollbar.setAttribute('aria-label', 'Product image thumbnails');
        customScrollbar.setAttribute('aria-valuemin', '0');
        customScrollbar.setAttribute('tabindex', '0');
        customScrollbarThumb.className = 'rr-v3-thumbnail-scrollbar__thumb';
        customScrollbar.appendChild(customScrollbarThumb);
        thumbnailRail.insertAdjacentElement('afterend', customScrollbar);

        const updateThumbnailScrollbar = () => {
          const maximum = Math.max(0, thumbnailRail.scrollWidth - thumbnailRail.clientWidth);
          const visibleRatio = Math.min(1, thumbnailRail.clientWidth / Math.max(thumbnailRail.scrollWidth, 1));
          const trackWidth = customScrollbar.clientWidth;
          const thumbWidth = Math.max(42, trackWidth * visibleRatio);
          const travel = Math.max(0, trackWidth - thumbWidth);
          const progress = maximum ? thumbnailRail.scrollLeft / maximum : 0;
          customScrollbar.hidden = maximum < 2;
          customScrollbarThumb.style.width = `${thumbWidth}px`;
          customScrollbarThumb.style.transform = `translateX(${travel * progress}px)`;
          customScrollbar.setAttribute('aria-valuemax', String(Math.round(maximum)));
          customScrollbar.setAttribute('aria-valuenow', String(Math.round(thumbnailRail.scrollLeft)));
        };

        const revealSelectedThumbnail = () => {
          const selected = thumbnailRail.querySelector('.swiper-slide-thumb-active');
          if (!selected || selected === currentThumbnail) return;
          currentThumbnail = selected;
          const centeredLeft = selected.offsetLeft - ((thumbnailRail.clientWidth - selected.offsetWidth) / 2);
          thumbnailRail.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'smooth' });
        };

        let dragStartX = 0;
        let dragStartScroll = 0;
        customScrollbar.addEventListener('pointerdown', (event) => {
          const maximum = Math.max(0, thumbnailRail.scrollWidth - thumbnailRail.clientWidth);
          if (!maximum) return;
          const trackBounds = customScrollbar.getBoundingClientRect();
          const thumbBounds = customScrollbarThumb.getBoundingClientRect();
          if (!customScrollbarThumb.contains(event.target)) {
            const ratio = Math.max(0, Math.min(1, (event.clientX - trackBounds.left) / trackBounds.width));
            thumbnailRail.scrollTo({ left: maximum * ratio, behavior: 'smooth' });
            return;
          }
          dragStartX = event.clientX;
          dragStartScroll = thumbnailRail.scrollLeft;
          customScrollbar.setPointerCapture(event.pointerId);
          const drag = (moveEvent) => {
            const travel = Math.max(1, trackBounds.width - thumbBounds.width);
            const target = dragStartScroll + ((moveEvent.clientX - dragStartX) / travel) * maximum;
            thumbnailRail.scrollLeft = Math.max(0, Math.min(maximum, target));
          };
          const stop = () => {
            customScrollbar.removeEventListener('pointermove', drag);
            customScrollbar.removeEventListener('pointerup', stop);
            customScrollbar.removeEventListener('pointercancel', stop);
          };
          customScrollbar.addEventListener('pointermove', drag);
          customScrollbar.addEventListener('pointerup', stop);
          customScrollbar.addEventListener('pointercancel', stop);
        });

        customScrollbar.addEventListener('keydown', (event) => {
          const maximum = Math.max(0, thumbnailRail.scrollWidth - thumbnailRail.clientWidth);
          const step = Math.max(60, thumbnailRail.clientWidth * 0.25);
          if (event.key === 'ArrowRight') thumbnailRail.scrollBy({ left: step, behavior: 'smooth' });
          else if (event.key === 'ArrowLeft') thumbnailRail.scrollBy({ left: -step, behavior: 'smooth' });
          else if (event.key === 'Home') thumbnailRail.scrollTo({ left: 0, behavior: 'smooth' });
          else if (event.key === 'End') thumbnailRail.scrollTo({ left: maximum, behavior: 'smooth' });
          else return;
          event.preventDefault();
        });

        revealSelectedThumbnail();
        updateThumbnailScrollbar();
        thumbnailRail.addEventListener('scroll', updateThumbnailScrollbar, { passive: true });
        window.addEventListener('resize', updateThumbnailScrollbar, { passive: true });
        window.setTimeout(updateThumbnailScrollbar, 300);
        new MutationObserver(revealSelectedThumbnail).observe(thumbnailRail, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }

    const paymentTerms = mainSection?.querySelector('shopify-payment-terms');
    if (paymentTerms) {
      paymentTerms.classList.add('rr-v3-payment-pending');
      let checks = 0;
      const revealCompleteTerms = () => {
        checks += 1;
        const text = paymentTerms.shadowRoot?.textContent?.trim() || '';
        if (/\$?\d/.test(text)) {
          paymentTerms.classList.remove('rr-v3-payment-pending');
          return;
        }
        if (checks < 24) window.setTimeout(revealCompleteTerms, 125);
      };
      revealCompleteTerms();
    }

    const deliveryChecker = purchaseGuidance?.querySelector('[data-rr-v3-delivery-checker]')
      || section.querySelector('[data-rr-v3-delivery-checker]');
    const deliveryForm = deliveryChecker?.querySelector('[data-rr-v3-delivery-form]');
    const deliveryStatus = deliveryChecker?.querySelector('[data-rr-v3-delivery-status]');

    if (deliveryChecker && deliveryForm && deliveryStatus) {
      const toRadians = (degrees) => degrees * (Math.PI / 180);
      const distanceInMiles = (lat1, lng1, lat2, lng2) => {
        const earthRadius = 3958.8;
        const deltaLat = toRadians(lat2 - lat1);
        const deltaLng = toRadians(lng2 - lng1);
        const a = Math.sin(deltaLat / 2) ** 2
          + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(deltaLng / 2) ** 2;
        return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      };

      const geocodeAddress = (address) => new Promise((resolve, reject) => {
        const callbackName = `rrV3Geocode${Date.now()}${Math.floor(Math.random() * 10000)}`;
        const script = document.createElement('script');
        const timer = window.setTimeout(() => finish(new Error('Address lookup timed out.')), 9000);

        const finish = (error, value) => {
          window.clearTimeout(timer);
          delete window[callbackName];
          script.remove();
          if (error) reject(error);
          else resolve(value);
        };

        window[callbackName] = (payload) => {
          const match = payload?.result?.addressMatches?.[0];
          if (!match?.coordinates) {
            finish(new Error('We could not find that address.'));
            return;
          }
          finish(null, match);
        };

        script.onerror = () => finish(new Error('Address lookup is temporarily unavailable.'));
        const params = new URLSearchParams({
          address,
          benchmark: 'Public_AR_Current',
          format: 'jsonp',
          callback: callbackName,
        });
        script.src = `https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?${params.toString()}`;
        document.head.appendChild(script);
      });

      const geocodeZip = async (zip) => {
        const response = await fetch(`https://api.zippopotam.us/us/${encodeURIComponent(zip)}`);
        if (!response.ok) throw new Error('We could not find that ZIP code.');
        const payload = await response.json();
        const place = payload?.places?.[0];
        const latitude = Number(place?.latitude);
        const longitude = Number(place?.longitude);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          throw new Error('We could not find that ZIP code.');
        }
        return {
          coordinates: { y: latitude, x: longitude },
          matchedAddress: `ZIP ${zip}`,
          precision: 'zip',
        };
      };

      const locateAddress = async (address) => {
        const zip = address.match(/\b(\d{5})(?:-\d{4})?\b/)?.[1];
        if (/^\d{5}$/.test(address)) return geocodeZip(address);
        try {
          return await geocodeAddress(address);
        } catch (addressError) {
          if (zip) return geocodeZip(zip);
          throw new Error('Enter a complete address including its 5-digit ZIP code.');
        }
      };

      deliveryForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const input = deliveryForm.querySelector('input[name="delivery-address"]');
        const button = deliveryForm.querySelector('button[type="submit"]');
        const address = input?.value.trim();
        if (!address || !button) return;

        deliveryStatus.className = 'rr-v3-delivery-form__status is-loading';
        deliveryStatus.textContent = 'Checking the address…';
        button.disabled = true;

        try {
          const match = await locateAddress(address);
          const distance = distanceInMiles(
            Number(deliveryChecker.dataset.storeLat),
            Number(deliveryChecker.dataset.storeLng),
            Number(match.coordinates.y),
            Number(match.coordinates.x),
          );
          const radius = Number(deliveryChecker.dataset.radius) || 50;
          const roundedDistance = Math.round(distance);

          const estimateSubject = match.precision === 'zip' ? `${match.matchedAddress} is estimated to be` : 'This address appears to be';

          if (distance <= radius) {
            deliveryStatus.className = 'rr-v3-delivery-form__status is-inside';
            deliveryStatus.textContent = `${estimateSubject} about ${roundedDistance} miles away and within our ${radius}-mile local area. Contact us to confirm the item, fee, timing, and access.`;
          } else {
            deliveryStatus.className = 'rr-v3-delivery-form__status is-outside';
            deliveryStatus.textContent = `${estimateSubject} about ${roundedDistance} miles away, outside our standard ${radius}-mile local area. Contact us to ask about other fulfillment options.`;
          }
        } catch (error) {
          deliveryStatus.className = 'rr-v3-delivery-form__status is-error';
          deliveryStatus.textContent = `${error.message} Please call or message our showroom and we’ll confirm your address personally.`;
        } finally {
          button.disabled = false;
        }
      });
    }

    const stickyBar = section.querySelector('[data-rr-v3-mobile-bar]');
    const stickyPrice = section.querySelector('[data-rr-v3-sticky-price]');
    const stickyAtc = section.querySelector('[data-rr-v3-sticky-atc]');

    if (!stickyBar || !stickyPrice || !stickyAtc || !mainAtc || !mainForm) return;

    const visiblePrice = () => {
      const candidates = [...mainSection.querySelectorAll('[data-product-pricing] [data-price]')];
      const current = candidates.find((node) => node.offsetParent !== null && !node.closest('[hidden]'));
      return current?.textContent?.trim() || '';
    };

    const syncSticky = () => {
      const price = visiblePrice();
      if (price) stickyPrice.textContent = price;
      stickyAtc.disabled = mainAtc.disabled;
      stickyAtc.textContent = mainAtc.querySelector('.atc-button--text')?.textContent?.trim() || (mainAtc.disabled ? 'Unavailable' : 'Add to cart');
    };

    syncSticky();
    new MutationObserver(syncSticky).observe(mainSection, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    mainForm.addEventListener('change', () => window.setTimeout(syncSticky, 0));
    stickyAtc.addEventListener('click', () => mainAtc.click());

    const showSticky = (show) => {
      if (window.innerWidth > 720) show = false;
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      stickyBar.style.bottom = previewBar ? `${Math.round(previewBar.getBoundingClientRect().height)}px` : '';
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('rr-v3-mobile-bar-visible', show);
    };

    const updateStickyVisibility = () => {
      const hasPassedNativeButton = mainAtc.getBoundingClientRect().bottom < 0;
      showSticky(hasPassedNativeButton);
    };

    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
  });
})();
